import { GetQueryParams, GetQueryResponse } from '../../../types/api.type';
import { InstructorCourseRequest } from '../../../types/course.type';
import { sfcApi } from '../../api';

export const instructorCourseRequest = sfcApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllInstructorCourseRequests: builder.query<GetQueryResponse, GetQueryParams | void>({
      query: (params) => ({
        url: 'instructor-course-requests',
        method: 'POST',
        body: params?.data
      })
    }),
    getInstructorCourseRequests: builder.query<
      { instructorCourseRequest: InstructorCourseRequest },
      number
    >({
      query: (id) => `instructor-course-requests/${id}`
    }),
    toggleInstructorCourseRequest: builder.mutation<
      boolean,
      { course_id: number; instructor_id: number; cancel: boolean }
    >({
      query: (body) => ({
        url: 'instructor-course-requests/toggle',
        method: 'POST',
        body
      }),
      invalidatesTags: ['Course']
    })
  })
});

export const {
  useGetAllInstructorCourseRequestsQuery,
  useGetInstructorCourseRequestsQuery,
  useToggleInstructorCourseRequestMutation
} = instructorCourseRequest;
